export const multiFactorAuthData = {
  newDevice: {
    title: "It looks like you're logging in from a new device",
    body: 'We sent an {methodType} to {method}. Pop in the security code below to log in.',
    inputLabel: 'Security code',
    buttonText: 'Log in'
  },
  tooManyAttempts: {
    title: "Whoops! Looks like you've tried too many times to enter the security code",
    body:
      'Oops! Too many incorrect code attempts. Try again in 15 mins or ' +
      '[chat with support]($open_live_chat).',
    buttonText: 'Back to login'
  }
};
